import { Injectable, inject } from '@angular/core';
import { downgradeInjectable } from '@angular/upgrade/static';
import App from '@app/app';
import { WINDOW } from '@app/core/window.token';

const FEATURE_FLAG_WINDOW_KEYS = {
  OPT_IN_EMAIL: 'optInEmailEnabled',
  MAX_JOB_CLEANUP: 'maxJobCleanupEnabled',
  DEFAULT_CYOP_ITEM: 'defaultCyopItem',
  UPSELL_BANNER: 'upsellBannerEnabled',
  SLASH_THROUGH_LOOKUP: 'slashThroughLookup',
  PERSISTENT_CART: 'persistentCartEnabledFlag',
  PREMIUM_BACKGROUND: 'premiumBackgroundEnabled',
  FAMILY_BANNER: 'familyBannerEnabled',
  STUDENT_CHICLET: 'studentChicletEnabled',
  OPTIMIZEPREPIC: 'optimizeprepic',
  BRAINTREE_PAYPAL_PAYLATER_FAIL: 'braintreePaypalPaylaterFailFlag',
  BRAINTREE_VENMO_FAIL: 'braintreeVenmoFailFlag',
  BRAINTREE_APPLE_PAY_FAIL: 'braintreeApplePayFailFlag',
  BRAINTREE_GOOGLE_PAY_FAIL: 'braintreeGooglePayFailFlag',
  BRAINTREE_ALL_PAYMENTS_FAIL: 'braintreeAllPaymentsFailFlag',
  ENABLE_ADDON_CATEGORY_FILTER: 'enableAddOnCategoryFilter',
  CLAIM_LOGIN_POPUP: 'claimLoginPopup',
  CART_LOGIN_POPUP: 'cartLoginPopup',
  REPRICE_CART_DEBOUNCE: 'repriceCartDebounceEnabled',
  REPRICE_CART_SEQUENCE: 'repriceCartSequenceEnabled',
  FAMILY_DISCOUNT_BANNER: 'familyDiscountBannerEnabled',
  SESSION_SYNC: 'sessionSyncEnabled',
  HOTJAR_SESSION_MAPPING: 'hotjarSessionMappingEnabled',
  SCREENSHOT_BLUR: 'screenshotBlurEnabled'
} as const;

type FeatureFlag = keyof typeof FEATURE_FLAG_WINDOW_KEYS;

type FeatureFlagWindow = Window & Partial<Record<(typeof FEATURE_FLAG_WINDOW_KEYS)[FeatureFlag], boolean | string>>;

@Injectable({
  providedIn: 'root'
})
export class FeatureFlagService {
  private readonly window = inject(WINDOW) as FeatureFlagWindow;

  public isEnabled(flag: FeatureFlag): boolean {
    const flagValue = this.window[FEATURE_FLAG_WINDOW_KEYS[flag]];

    return flagValue === '0' ? false : Boolean(flagValue);
  }
}

App.factory('FeatureFlagService', downgradeInjectable(FeatureFlagService));
